import React from 'react';
import { useSelector } from 'react-redux';
import { withI18n } from '@lingui/react';
import get from 'lodash/get';

import { selectors as appSelectors } from '../../../reducers/appReducer';
import { getLocaleFromLanguageCode } from '../../../intl-helpers';

const MAX_VISIBLE_PROPERTIES = 7;

const ProfilePropertiesBadges = ({ rules = [], i18n }) => {
    const productProperties = useSelector(appSelectors.getProductProperties);
    const langCode = getLocaleFromLanguageCode(i18n.language);

    const getLabel = (code) => {
        if (productProperties[code]) {
            return get(productProperties[code], `label.${langCode}`, code);
        }
        return code;
    };

    const hasAllProperties = rules.some((rule) => rule.target === 'all properties');

    if (hasAllProperties) {
        return <span className="label label-success" style={{ display: 'inline-block' }}>ALL</span>;
    }

    const properties = rules.flatMap((rule) => rule.properties || []);

    if (properties.length === 0) return '—';

    const visible = properties.slice(0, MAX_VISIBLE_PROPERTIES);
    const remaining = properties.length - visible.length;

    return (
        <>
            {visible.map((prop) => (
                <span key={prop} className="label label-primary mr-1 mb-1" style={{ display: 'inline-block' }}>
                    {getLabel(prop)}
                </span>
            ))}
            {remaining > 0 && (
                <span
                    className="label label-primary mr-1 mb-1 tooltip"
                    style={{ display: 'inline-block' }}
                    data-tooltip={properties.slice(MAX_VISIBLE_PROPERTIES).map(getLabel).join(', ')}
                >
                    +{remaining}
                </span>
            )}
        </>
    );
};

export default withI18n()(ProfilePropertiesBadges);